import { useOptionalUser } from '@src/providers/UserProvider'
import { Outlet } from 'react-router-dom'
import { UserRight } from '../../data/types'
import NotAuthorizedPage from './NotAuthorizedPage'

interface Props {
  requiredPermission: UserRight
}

const RouteGuard = ({ requiredPermission }: Props) => {
  const user = useOptionalUser()
  return user?.rights[requiredPermission] === true ? <Outlet /> : <NotAuthorizedPage />
}

export default RouteGuard
